<template>
   
 
  <el-dialog
  v-model="showOverlay"
  destroy-on-close
  width="55%" 
  center
  custom-class="dialogo">
    <h6 class="eres"> ¿Es profesional de la salud? </h6>
    <p class="este">Este sitio contiene información acerca del padecimiento Alfa-Manosidosis.
       ¿Es usted profesional de la salud apto para la prescripción de medicamentos?</p>
    <template #footer >
      <span class="dialog-footer">
        <button class="escoge" @click="scrollPageTo()"> Si lo soy, llévame </button>
        <button class="escoge" @click="modal"> No, no lo soy </button>
    
      </span>
    </template>
  </el-dialog>
  
        
</template>

<script>
import { useStore } from 'vuex'

import { computed } from 'vue'

export default {
    setup() {
      
      const store = useStore()
      const showOverlay = computed(() => store.state.showOverlay)
      const showMaterial = computed(() => store.state.showMaterial)
      const checkSintomas = computed(() => store.state.checkSintomas)   
      const mater = () => store.commit('mater')
      const modal = () => store.commit('modal')

      
      const scrollPageTo = () => {
      mater()
      modal()
      console.log(showMaterial.value)
      document.querySelector(".el-menu--inline").style.display = "none"
     
      console.log('modallll'+screen.width)
      if(screen.width < 500){
          window.scrollTo({top:2520, behavior:'smooth'})
        }
      if((screen.width >500) &&(screen.width < 769)){
                window.scrollTo({top:2500, behavior:'smooth'})
              }
      if(screen.width > 769){
        window.scrollTo(0,2270)
      setTimeout(() =>{
        
      window.scrollBy({top:750, behavior:'smooth'})
      
      },100)
        console.log('waaat?')
      }
       
   }

      return { showOverlay, mater, modal,showMaterial,
      checkSintomas, scrollPageTo } 
    },
}
</script>
<style lang="scss" >
  .dialogo{
    background-color:#000D5A !important;
    border-radius: 30px !important;
    margin-top: 20vh !important;
  }
    .eres{
      color: #fff;
      font-family: "Yusei-Magic";
      font-size: 40px;
      font-style: normal;
      font-weight: 400;
      line-height: 70px;
      letter-spacing: 0em;
      text-align: center;
      margin-top:20px;
      margin-bottom: 20px;
      
      word-break: break-word;
    }
    .este{
      color: #fff;
      font-family: "Avenir";
      font-weight: 100;
      line-height: 30px;
      letter-spacing: 0em;
      text-align: center;
      font-size: 18px;
      padding-left: 20%;
      padding-right: 20%;
      margin-top: 40px;
      word-break: break-word;

    }
    .escoge{
      color: #fff;
      width: 280px;
      background-color: transparent;
      border: 1px solid #fff;
      height: 60px;
      font-size: 20px;
      border-radius: 18px;
      margin: 15px;
    }
    .escoge:hover{
      cursor: pointer;
      background-color: transparent;
      color: #000D5A;
      font-weight: 600;
      box-shadow: 50px 100px 100px 50px (255,255,255,.6);
    }
    .mup{
      margin-top: 60px;
    }
    @media (max-width:768px) {
      .dialogo{
        width: 90% !important;
        
      }
      @media (max-width:500px) {
        .dialogo{
          width: 95% !important;
          margin-top:50px !important ;
          z-index: 9999999999 !important;
        }
        .este{
          word-break: break-word;
        }
        .eres{
          font-size: 35px;
        }
      }
    }
</style>